import { h } from 'preact'
import PageInfo from './PageInfo'
import Pager from './Pager'
import DropdownControl from '../dropdown/DropdownControl'
import PageSizeSelector from './PageSizeSelector'
import ButtonControl from '../button-control/index'
import Icon from '../assets/index'
import Tooltip from '../ui-components/Tooltip'

type PaginationProps = {
  currentPage: number,
  total: number,
  pageSize: number,
  pageSizes: Array<number>,
  onPageChange: (page: number) => void,
  onPageSizeChange: (pageSize: number) => void,
  displayListUpwards?: boolean
}


export const calculateTotalPages = (total: number, pageSize: number) => Math.ceil(total / pageSize)

const Pagination = ({ currentPage, total, pageSize, pageSizes, onPageChange, onPageSizeChange, displayListUpwards }: PaginationProps) => {
  const totalPages = calculateTotalPages(total, pageSize)
  const start = (currentPage * pageSize) - pageSize + 1
  const end = start - 1 + (currentPage === totalPages && (total % pageSize) !== 0 ? (total % pageSize) : pageSize)
  const isEqualOrOverTenThousand = total >= 10000

  return (
    <div class='control-pagination'>
      <span class='control-pagination--info'>
        {start}-{end} of {total}{ isEqualOrOverTenThousand && '+'} results
        { isEqualOrOverTenThousand &&
          <Tooltip
            trigger={<Icon icon='question' width={16} height={16} />}
            tooltipMessage='We limit the results to 10,000 to ensure speedy loading times ⚡'
            withArrow
            position='center'
            noWrap
            top={24}
          />
        }
      </span>
      <Pager isDisabled={currentPage === 1} onClick={() => onPageChange(1)} customClass='qa-pager-first'><a>First</a></Pager>
      <Pager isDisabled={currentPage === 1} isChevron onClick={() => onPageChange(currentPage - 1)}><Icon width={16} height={16} icon={'chevronLeft'} /></Pager>
      <PageInfo currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
      <Pager isDisabled={currentPage === totalPages} isChevron onClick={() => onPageChange(currentPage + 1)}><Icon width={16} height={16} icon={'chevronRight'} /></Pager>
      <Pager isDisabled={currentPage === totalPages} onClick={() => onPageChange(totalPages)} customClass='qa-pager-last'><a>Last</a></Pager>
      <DropdownControl
        closeOnDropdownClick
        displayListUpwards={displayListUpwards}
        align={'adjust'}
        trigger={<ButtonControl title={`${pageSize} rows`} class={'control-pagination--page-selector'} icon={'arrowDropdown'} />}
        items={PageSizeSelector(pageSizes, onPageSizeChange)}
      />
    </div>
  )
}

export default Pagination
